import { normalizeRole } from './fieldAccess';

export type FieldNavIcon = 'home' | 'task' | 'workers' | 'attendance' | 'time' | 'qc' | 'defect' | 'inspection' | 'dfr' | 'dispatch' | 'emergency' | 'accounts' | 'approval' | 'transactions' | 'close' | 'procurement' | 'orders' | 'risk' | 'suppliers' | 'stores' | 'receiving' | 'picking' | 'stock' | 'history';

export interface FieldNavigationItem {
  label: string;
  path: string;
  icon: FieldNavIcon;
}

const navigation: Record<string, FieldNavigationItem[]> = {
  admin: [
    { label: 'Home', path: '/field', icon: 'home' },
    { label: 'Users', path: '/field/admin/users', icon: 'workers' },
    { label: 'Teams', path: '/field/admin/teams', icon: 'accounts' },
    { label: 'Field Mode', path: '/field/admin/field-mode', icon: 'inspection' },
    { label: 'History', path: '/field/admin/history', icon: 'history' },
  ],
  worker: [
    { label: 'Home', path: '/field', icon: 'home' },
    { label: 'Current Task', path: '/field/tasks', icon: 'task' },
    { label: 'Attendance', path: '/field/attendance', icon: 'attendance' },
    { label: 'Work Plan', path: '/field/upcoming', icon: 'time' },
    { label: 'Performance', path: '/field/performance', icon: 'workers' },
    { label: 'Safety', path: '/field/worker/emergency', icon: 'emergency' },
  ],
  supervisor: [
    { label: 'Home', path: '/field', icon: 'home' },
    { label: 'Current', path: '/field/supervisor/current', icon: 'inspection' },
    { label: 'Work Plan', path: '/field/supervisor/upcoming', icon: 'time' },
    { label: 'Attendance', path: '/field/attendance', icon: 'attendance' },
    { label: 'Field Report', path: '/field/dfr', icon: 'dfr' },
    { label: 'Timesheets', path: '/field/timesheets', icon: 'time' },
    { label: 'Safety', path: '/field/emergency', icon: 'emergency' },
  ],
  accounts: [
    { label: 'Home', path: '/field', icon: 'home' },
    { label: 'PO Pay', path: '/field/accounts/purchase-orders', icon: 'orders' },
    { label: 'Task Pay', path: '/field/accounts/construction-tasks', icon: 'approval' },
    { label: 'Other Payments', path: '/field/accounts/other-transactions', icon: 'transactions' },
    { label: 'Completed Transactions', path: '/field/accounts/transactions', icon: 'history' },
    { label: 'Drawdown', path: '/field/accounts/drawdown', icon: 'accounts' },
  ],
  procurement: [
    { label: 'Home', path: '/field', icon: 'procurement' },
    { label: 'Current PO', path: '/field/procurement/orders', icon: 'orders' },
    { label: 'Schedule', path: '/field/procurement/at-risk', icon: 'time' },
    { label: 'Suppliers', path: '/field/procurement/suppliers', icon: 'suppliers' },
  ],
  stores: [
    { label: 'Home', path: '/field', icon: 'stores' },
    { label: 'Receiving', path: '/field/stores/receiving', icon: 'receiving' },
    { label: 'Pick & Issue', path: '/field/stores/picking', icon: 'picking' },
    { label: 'Stock', path: '/field/stores/stock', icon: 'stock' },
  ],
  qs: [
    { label: 'Home', path: '/field', icon: 'home' },
    { label: 'Drawdown', path: '/field/qs/drawdown', icon: 'transactions' },
    { label: 'Approved Drawdowns', path: '/field/qs/previous-drawdowns', icon: 'approval' },
  ],
  pm: [
    { label: 'Home', path: '/field', icon: 'home' },
    { label: 'Look Ahead', path: '/field/pm/lookahead', icon: 'time' },
    { label: 'Dispatch', path: '/field/pm/dispatch', icon: 'dispatch' },
    { label: 'Issued Tasks', path: '/field/pm/issued', icon: 'task' },
    { label: 'Submitted Reports', path: '/field/pm/submitted-reports', icon: 'dfr' },
    { label: 'Reviews', path: '/field/pm/reviews', icon: 'inspection' },
  ],
  executive: [
    { label: 'Home', path: '/field', icon: 'home' },
    { label: 'Estate Progress', path: '/field/executive/estate-progress', icon: 'home' },
    { label: 'Construction Tasks', path: '/field/executive/construction-tasks', icon: 'task' },
    { label: 'Supervisor Inspections', path: '/field/executive/supervisor-inspections', icon: 'inspection' },
    { label: 'Stores', path: '/field/executive/stores', icon: 'stores' },
    { label: 'Procurement', path: '/field/executive/procurement', icon: 'procurement' },
    { label: 'Financial', path: '/field/executive/financial', icon: 'transactions' },
  ],
};

export const fieldNavigationForRole = (role?: string | null): FieldNavigationItem[] => {
  const normalized = normalizeRole(role);
  if (normalized === 'admin' || normalized === 'field_admin') return navigation.admin;
  if (normalized === 'supervisor') return navigation.supervisor;
  if (normalized === 'accounts') return navigation.accounts;
  if (normalized === 'procurement') return navigation.procurement;
  if (normalized === 'stores') return navigation.stores;
  if (normalized === 'qs') return navigation.qs;
  if (normalized === 'pm') return navigation.pm;
  if (normalized === 'executive') return navigation.executive;
  return navigation.worker;
};
